import { Button, Card, Space, Typography } from "antd";
import { useParams } from "react-router";
import { LinkOutlined } from "@ant-design/icons";

const APP_URL = import.meta.env.VITE_MAIN_APP_URL || "https://app.example.com";

const STATUS_MAP: Record<
  string,
  { title: string; description: string; reason: string }
> = {
  "404": {
    title: "Remote concentrator not found",
    description:
      "The slug you requested does not match any known concentrator. Check the URL and try again.",
    reason: "Slug missing or mistyped",
  },
  "502": {
    title: "Unable to reach concentrator",
    description:
      "The concentrator is unreachable right now. We are routing the request back to the main app.",
    reason: "Gateway unavailable",
  },
};

export const RemoteErrors = () => {
  const { code } = useParams<{ code?: string }>();
  const status = code || "unknown";
  const details = STATUS_MAP[status] ?? {
    title: "Remote access error",
    description: "An unexpected error happened while reaching the concentrator.",
    reason: "unknown",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
        background: "#f5f5f5",
      }}
    >
      <Card style={{ maxWidth: 600, width: "100%" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Typography.Title level={3}>{details.title}</Typography.Title>
          <Typography.Text type="secondary">{details.description}</Typography.Text>
          <Typography.Text type="secondary">
            Reason: {details.reason} (status {status})
          </Typography.Text>
          <Button
            type="primary"
            href={APP_URL}
            icon={<LinkOutlined />}
            block
          >
            Return to the main app
          </Button>
        </Space>
      </Card>
    </div>
  );
};
